import React, { useCallback, useEffect } from "react";
import style from "./style/cards.module.scss";
import book from "../../assets/book.png";
import { handlerContentData } from "./utils";
import { useDispatch, useSelector } from "react-redux";
import SelectedCardContent from "./selectedCard";
import { selectCardContent } from "../../store/Slices/menuContent";

const Cards = ({ item_id, onCardClick }) => {
    const dispatch = useDispatch();

    const selectedCard = useSelector(state => state.menuContent.selectedCard);
    const selectedSubcategory = useSelector(state => state.menuContent.selectedSubcategory);

    const goBack = useCallback(() => {
        dispatch(selectCardContent(null));
        sessionStorage.removeItem("selectedCard");
    }, [dispatch]);

    const selectCard = (title) => {
        dispatch(selectCardContent(title));
        sessionStorage.setItem("selectedCard", title);
    };

    useEffect(() => {
        const storedTitle = sessionStorage.getItem("selectedCard");
        if (storedTitle && !handlerContentData(selectedSubcategory, item_id).some(item => item.name === storedTitle)) {
            sessionStorage.removeItem("selectedCard");
            dispatch(selectCardContent(null));
        }
    }, [dispatch, selectedSubcategory, item_id]);

    if (selectedCard) {
        const selectedItem = handlerContentData(selectedSubcategory, item_id).find(item => item.name === selectedCard);
        return <SelectedCardContent title={selectedCard} file={selectedItem?.file} goBack={goBack} />;
    }

    return (
        <div className={style.boxes}>
            <div className={style.cards}>
                {
                    handlerContentData(selectedSubcategory, item_id).map(({ id, name, info, file }) => {
                        const isLink = typeof info === 'string' && (info.startsWith('http://') || info.startsWith('https://'));

                        return (
                            <div
                                key={id + name}
                                className={style.card}
                                onClick={(e) => {
                                    if (!isLink) {
                                        e.stopPropagation();
                                        selectCard(name);
                                        if (onCardClick) {
                                            onCardClick();
                                        }
                                    }
                                }}
                            >
                                <img src={book} alt="book" />
                                <h1>{name}</h1>
                                {
                                    isLink ? (
                                        <a
                                            href={info}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: 'black', textDecoration: 'none' }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            Բացել հղումը
                                        </a>
                                    ) : (
                                        <span>{info}</span>
                                    )
                                }
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

export default Cards;
